import React from 'react';
import {Button, Dropdown, Menu} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';
import {BookOutlined, HomeOutlined, MenuOutlined, SettingOutlined} from '@ant-design/icons';
import {ROUTE_NAMES, ROUTES} from '../../routes/constants';
import './Navigation.css';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // 外部链接配置
  const externalLinks : {key: string, icon: React.ReactElement, label: string; url: string;}[]= [
    {
      key: 'external-docs',
      icon: <BookOutlined />,
      label: '博客',
      url: 'https://blog.imgbed.cn/',
    },
    // {
    //   key: 'external-docs',
    //   icon: <BookOutlined />,
    //   label: '使用指南',
    //   url: 'https://www.yuque.com/aowufudongdong/kb/doa7yc25suqyq5y2',
    // },
    // {
    //   key: 'external-config',
    //   icon: <SettingOutlined />,
    //   label: '配置文档',
    //   url: 'https://www.yuque.com/aowufudongdong/kb/nlg8gih5hrv2tv3c',
    // },
    // {
    //   key: 'external-faq',
    //   icon: <QuestionCircleOutlined />,
    //   label: '常见问题',
    //   url: 'https://www.yuque.com/aowufudongdong/kb/og9axmho8yc8w71c',
    // },
  ];

  // 内部路由菜单项
  const internalMenuItems = [
    {
      key: ROUTES.HOME,
      icon: <HomeOutlined />,
      label: ROUTE_NAMES[ROUTES.HOME],
    },
    // {
    //   key: ROUTES.ABOUT,
    //   icon: <InfoCircleOutlined />,
    //   label: ROUTE_NAMES[ROUTES.ABOUT],
    // },
  ];

  // 外部链接菜单项
  const externalMenuItems = externalLinks.map(link => ({
    ...link,
    onClick: () => {
      window.open(link.url, '_blank', 'noopener,noreferrer');
    },
  }));

  // 合并所有菜单项
  const menuItems = [...internalMenuItems, ...externalMenuItems];

  const handleMenuClick = ({ key }: { key: string }) => {
    // 检查是否为外部链接
    if (key.startsWith('external-')) {
      // 外部链接已经在 menuItems 中通过 onClick 处理
      return;
    }
    // 内部路由导航
    navigate(key);
  };

  return (
    <>
      {/* 桌面端导航菜单 */}
      <div className="desktop-navigation">
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            border: 'none',
            background: 'transparent',
            flex: 1,
            marginLeft: '0px',
          }}
        />
      </div>

      {/* 移动端下拉菜单 */}
      <div className="mobile-navigation">
        <Dropdown
          menu={{
            items: menuItems,
            selectedKeys: [location.pathname],
            onClick: handleMenuClick,
          }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button
            type="text"
            icon={<MenuOutlined />}
            style={{
              fontSize: '18px',
              color: '#4C5362',
              border: 'none',
              padding: '8px',
              height: '40px',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          />
        </Dropdown>
      </div>
    </>
  );
};

export default Navigation; 